import { BuildGraphFromTraversalAndSearchParams } from '../types';
import { TraversalAndGroupingResult } from '../traversal/types';
import * as profiling from '@ardoq/profiling';
import { isGraphModelValid } from '../viewModel/isGraphModelValid';
import { logError } from '@ardoq/logging';
import { getTraversalResultForViewpointMode } from './getTraversalResultForViewpointMode';
import { getTraversalAndGroupingResult } from './getTraversalAndGroupingResult';
import { getEmptyTraversalAndGroupingResult } from './utils';

export const buildGraphFromTraversalAndSearch: (
  params: BuildGraphFromTraversalAndSearchParams
) => TraversalAndGroupingResult = ({
  graph,
  groupingRules = [],
  viewId,
  loadedGraph,
  graphInterface,
  i18nLocale,
  canBeUsedAsGroup = () => true,
}: BuildGraphFromTraversalAndSearchParams) => {
  const transaction = profiling.startTransaction(
    'buildGraphPhoenixMode',
    500,
    profiling.Team.CORE
  );

  if (!isGraphModelValid(graphInterface, graph)) {
    // typically this means the graphModel$ has not updated itself with the latest state of the References collection... but a viewModel stream is rebuilding from some other update.
    logError(Error('Invalid graph model.'), null, {
      viewId,
      referenceCollectionSize: graphInterface.getReferenceCollectionSize(),
      referenceMapSize: graph.referenceMap.size,
    });
    return getEmptyTraversalAndGroupingResult();
  }

  const { componentIds, traversedReferenceIds, parentReferenceIds } =
    getTraversalResultForViewpointMode({
      loadedGraph,
      graph,
    });

  const traversalAndGroupingResult = getTraversalAndGroupingResult({
    graphInterface,
    graph,
    componentIds,
    traversedReferenceIds,
    parentReferenceIds,
    groupingRules,
    isParentRelationAsReference: true,
    canBeUsedAsGroup,
    useNewGrouping: false, // always false for viewpoint mode
    i18nLocale,
  });

  profiling.endTransaction(transaction, {
    viewId,
    metadata: {
      groupCount: traversalAndGroupingResult.groupMap.size,
      // Setting these traversal config values to -1, we don't do any
      // local traversal in viewpoint mode.
      maxDegrees: -1,
      maxDegreesIncoming: -1,
      maxDegreesOutgoing: -1,
      startSetCount: -1,
      referenceCount: graph.referenceMap.size,
      sourceCount: graph.sourceMap.size,
      targetCount: graph.targetMap.size,
    },
  });

  return traversalAndGroupingResult;
};
